<div class="card-body p-3">

    <div class="row">
        <div class="col col-md-3">
            <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect"></app-benef-info>

        </div>
        <div class="col col-md-9">
            <div class="row">
                <div class="col-md-12">
                    <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
                </div>


            </div>
            <div *ngIf="itemBeneficiare?.id" class="mt-2">
                <div style="max-height: 200px;overflow-y: auto;">
                    <table class="prescription-table">
                        <thead>
                            <tr>
                                <th scope="col"># <i class="fa fa-redo" (click)="getItemsPrescriptionActive()"></i></th>
                                <th scope="col">Libelle</th>
                                <th scope="col">Date consultation</th>
                                <th scope="col">Date expiration</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [class.active-row]="item.is_active"
                                *ngFor="let item of itemsPrescription; let i = index" (click)="onSelectRow(item)">
                                <th>{{ i + 1 }}</th>
                                <!-- <td>{{ item.codification }}</td> -->
                                <td>{{ item.libelle }}</td>
                                <td>{{ item.created_at | date:'dd/MM/yyyy' }}</td>
                                <td>
                                    <!-- Add expiration date if available -->
                                    {{ item.date_expiration ? (item.date_expiration | date:'dd/MM/yyyy') : 'N/A' }}
                                </td>
                                <td class="blink">
                                    <!-- Add expiration date if available -->
                                    {{ item.is_controle?'Controle':'' }}
                                </td>
                            </tr>
                            <tr *ngIf="!itemsPrescription || !itemsPrescription.length">
                                <td colspan="5" style="text-align: center;">
                                    Auncune donnée trouvée
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>




                <!-- Medication Add Form -->
                <div class="card mb-4" *ngIf="selectedConsultation && selectedConsultation.id">
                    <div class="card-body">

 <div class="consultation-form-container">
      <form class="dental-consultation-form" (ngSubmit)="confirmSaveItem(itemToSave)">
        <div class="form-group">
          <label for="motif">Motif de consultation *</label>
          <select 
            id="motif" 
            [(ngModel)]="itemToSave.motif_consultation" 
            name="motif_consultation"
            required>
            <option value="">Sélectionner un motif</option>
            <option value="controle">🔍 Contrôle de routine</option>
            <option value="douleur">😣 Douleur dentaire</option>
            <option value="carie">🦷 Traitement de carie</option>
            <option value="detartrage">✨ Détartrage</option>
            <option value="prothese">🔧 Prothèse dentaire</option>
            <option value="orthodontie">📏 Orthodontie</option>
            <option value="extraction">⚕️ Extraction</option>
            <option value="autre">📝 Autre</option>
          </select>
        </div>

        <div class="form-group">
          <label for="zone">Zone affectée</label>
          <div class="zone-input-container">
            <textarea 
              id="zone" 
              [(ngModel)]="itemToSave.zone_affectee" 
              name="zone_affectee"
              placeholder="Ex: Molaire sup. droite"
              rows="3"
              (focus)="showZoneSuggestions = true"
              #zoneInput></textarea>
            <div class="zone-suggestions" *ngIf="showZoneSuggestions">
              <div class="suggestions-header">
                <span>Suggestions (cliquez pour ajouter):</span>
                <button 
                  type="button" 
                  class="close-suggestions-btn"
                  (click)="showZoneSuggestions = false"
                  title="Fermer les suggestions">
                  ×
                </button>
              </div>
              <div class="suggestions-grid">
                <button 
                  type="button" 
                  class="suggestion-btn"
                  [class.selected]="isZoneSelected(suggestion)"
                  *ngFor="let suggestion of zoneSuggestions"
                  (click)="toggleZoneSuggestion(suggestion)">
                  <span class="suggestion-text">{{ suggestion }}</span>
                  <span class="suggestion-check" *ngIf="isZoneSelected(suggestion)">✓</span>
                </button>
              </div>
            </div>
          </div>
          <div class="field-hint">Précisez la dent ou zone concernée. Séparez par ";" pour plusieurs zones</div>
        </div>

        <div class="form-group">
          <label for="douleur">Niveau de douleur</label>
          <div class="pain-scale">
            <input 
              type="range" 
              id="douleur" 
              min="0" 
              max="10" 
              [(ngModel)]="itemToSave.douleur_niveau" 
              name="douleur_niveau"
              class="pain-slider">
            <div class="pain-labels">
              <span class="pain-value">{{ itemToSave.douleur_niveau || 0 }}/10</span>
              <div class="pain-indicator" [ngClass]="getPainClass()">
                {{ getPainLabel() }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="observations">Notes et observations</label>
          <div class="textarea-wrapper">
            <textarea 
              id="observations" 
              [(ngModel)]="itemToSave.observations" 
              name="observations"
              placeholder="Observations particulières du praticien..."
              rows="4"></textarea>
            <div class="textarea-counter">{{ getTextLength() }}/500</div>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="onCancel()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2"/>
            </svg>
            Annuler
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="!isFormValid()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" fill="none"/>
            </svg>
            Enregistrer la consultation
          </button>
        </div>
      </form>
    </div>
                        




                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Patient Information -->


    <!-- Prescription Form -->

</div>